class Request {
  constructor(req) {
    this.data = req.data
  }
}

export default Request
